import React from "react";
import "./CeCreateAccount.css";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";
import Header from "../CeHeader/Header";
import { LinearProgress } from '@mui/material';
import Button from '@mui/material/Button';
import withSnackbar from "../../util/withSnackbar";
import { COGNITO_EXCEPTION_WORDING_MAPPER } from '../../constants/CognitoErrorConstants';
import { SNACKBAR_OPTIONS, TIMEOUT } from '../../constants/CommonConstants';
import CompletionDialog from "../Common/CompletionDialog";
import { errorHandle } from '../../Common/errorHandle';

class ceCreateAccount extends React.Component{

    constructor(props) {
        super(props);
        this.validateInput = this.validateInput.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            email: '',
            authorizerDisplay: 'none',
            error: '',
            authorizer: '',
            isCompleteDialog: false,
            isProgress: false,
        };
    };

    validateInput() {
        var re = /\S+@\S+\.\S+/;
        var error = '';
        var checkAuthorizer = this.state.authorizerDisplay === 'block';
        var fieldsAbsent = this.state.email === '' || (checkAuthorizer && this.state.authorizer === '');
        if(fieldsAbsent) {
            error = error.concat(this.props.intl.formatMessage({ id: "fields_compulsory" }))
        }
        if(!re.test(this.state.email) ){
            error = error.concat(this.props.intl.formatMessage({ id: "email_error" }))
        }
        if( checkAuthorizer && !re.test(this.state.authorizer) ){
            error = error.concat(this.props.intl.formatMessage({ id: "authorizer_email_error" }))
        }
        return error;
    }

    register() { 
        var error = this.validateInput();
        this.setState({ error: error });
        if(error === '') {
            const controller = new AbortController();
            const props = this;
            const timer = window.setTimeout(errorHandle(function() {
                controller.abort();
                throw props;
            }), TIMEOUT);
            this.setState({isProgress:true});
            fetch(process.env.REACT_APP_CE_ACCOUNT, {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                signal: controller.signal,
                body: JSON.stringify({
                    mailAddress : this.state.email,
                    authorizerMailAddress : this.state.authorizer,
                }),
            }).then(res => {
                window.clearTimeout(timer);
                if (res.ok) {
                    if (this.state.authorizerDisplay === 'none') {
                        this.setState({ isCompleteDialog: true });
                    } else {
                        this.setState({ isCompleteDialog: true });
                    }
                } else {
                    return res.json();
                }
            }).then(response => {
                if (response && response.status !== 200) {
                    this.setState({error:this.props.intl.formatMessage({ id: COGNITO_EXCEPTION_WORDING_MAPPER[response.code] })})
                }
            }).catch(error => {
                this.props.openSnackbar(this.props.intl.formatMessage({ id: "server_error" }));
            }).finally(() => {
                this.setState({isProgress: false});
            });
        }
    }

    goBack(){
        this.props.history.push({
            pathname: '/'
        });
    }

    onEmailChange(value) {
        this.setState({ email: value });
        this.setState({ error: '' });
        this.setState({authorizerDisplay : 'block'});
    }

    onEmailValidation(event) {
        let regexp = /^[A-Za-z0-9_.\-@]+$/;
        let str = event.target.value;
        if(!regexp.test(str)) {
            str = str.split('').filter((char) => regexp.test(char) === true).join('')
            event.target.value = str;
        }
    }

    handleClose() {
        this.setState({ isCompleteDialog: false });
        this.props.history.push({
            pathname: '/',
        });
    }

    render() {
        return (
            <div id="ceCreateAccount" className="body">
                {this.state.isProgress ? <LinearProgress /> : ''}
                <Header showSubMenu={false} />
                <div className="form">
                    <div className="label email">
                        <span>
                            *{this.props.intl.formatMessage({ id: "email" })}
                        </span>
                    </div>
                    <div className="inputField">
                        <input 
                            type="email" 
                            name="email" 
                            size="45" 
                            maxLength="128" 
                            onInput={event =>{this.onEmailValidation(event)}} 
                            onChange={event =>{this.onEmailChange(event.target.value)}}
                        />
                    </div>
                    <div className="label userName">
                        <span>
                            *{this.props.intl.formatMessage({ id: "user_id" })}
                        </span>
                    </div>
                    <div className="inputField userName">
                        <input type="email" name="userName" value={this.state.email} size="45" disabled/>
                    </div>
                    <div className="authorizer" >
                        <div className="label">
                            <span>
                                *{this.props.intl.formatMessage({ id: "ce_authorizer" })}
                            </span>
                        </div>
                        <div className="inputField authorizer">
                            <input 
                                type="email" 
                                name="authorizer" 
                                size="45" 
                                maxLength="128" 
                                onInput={event =>{this.onEmailValidation(event)}} 
                                onChange={event => {this.setState({authorizer: event.target.value})}}
                            />
                        </div>
                        <div className="inputField authorizer-text">
                            <textArea type="text" name="authorizer-text" cols="48" rows="5" disabled>
                                {this.props.intl.formatMessage({ id: "authorizer_text" })}
                            </textArea>
                        </div>
                    </div>
                    <div className="buttons">
                        <Button fullWidth className="button registerButton" onClick={() => this.register()}>
                            {this.props.intl.formatMessage({ id: "register" })}
                        </Button>
                        <Button fullWidth className="button backButton" onClick={() => this.goBack()}>
                            {this.props.intl.formatMessage({ id: "header_cancel" })}
                        </Button>
                    </div>
                    <div className="errMsg">
                        <span>
                            {this.state.error}
                        </span>
                    </div>    
                </div>
                <CompletionDialog 
                    show={this.state.isCompleteDialog}
                    handleClose={this.handleClose}
                    intl={this.props.intl}
                    message={"ce_account_complete_dealer"}
                />
            </div>
        )
    }

}
export default withSnackbar(withRouter(injectIntl(ceCreateAccount)), SNACKBAR_OPTIONS);
